
// Dependencies
import Vue from 'vue'
// import VueRouter from 'vue-router'
import vueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueProgressBar from 'vue-progressbar'
import Meta from 'vue-meta'
import Clipboard from 'v-clipboard'

import router from './router'


Vue.config.productionTip = false


Vue.use(Clipboard)
// Vue.use(VueRouter)
Vue.use(Meta)
Vue.use(vueResource)
Vue.use(VeeValidate)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '5px'
})


/* eslint-disable no-new */
new Vue({
  router,
  template: `
    <div id="app">
      <vue-progress-bar></vue-progress-bar>
      <router-view></router-view>
    </div>
    `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js